import React from 'react';
import {
  IGenericResponse,
  IRouteScreenProps,
  ISupplierUserProfile,
} from 'constants/interfaces';
import {apiOnboardSupplier, OnboardSupplierInput} from 'constants/Api';
import {STORAGE_ACTION} from 'services/LocalStorageService';
import {connect} from 'react-redux';
import {
  InviteSupplierForm,
  InviteSupplierFormSubmission,
} from 'screens/Dashboard/InviteSupplier/InviteSupplierForm';

type InviteProps = IRouteScreenProps & {
  user: ISupplierUserProfile;
};

class InviteSupplier extends React.Component<InviteProps> {
  state: {
    isLoading: boolean;
    isSuccess: boolean;
  } = {
    isLoading: false,
    isSuccess: false,
  };

  componentDidMount() {}

  handleFormSubmission(submission: InviteSupplierFormSubmission) {
    this.setState({isLoading: true}, () => {
      const companyPermissions = {...submission.companyPermissions};
      delete companyPermissions.purchaseOrders;
      delete companyPermissions.orderBundles;
      delete companyPermissions.onboarding;

      const input: OnboardSupplierInput = {
        company: submission.company,
        companyPermissions: companyPermissions,
        depots: [submission.defaultDepot],
        adminUser: submission.adminUser,
        isCommodityGroup: submission.isCommodityGroup,
      };
      // Persist pending company permissions keyed by the invited admin email.
      // Defensive client-side fallback in case backend doesn't immediately persist.
      try {
        const key = `pendingPermissions:${submission.adminUser.email || ''}`;
        console.log(
          'Storing pending permissions for',
          submission.adminUser.email,
          submission.companyPermissions, // store the full set locally
        );
        STORAGE_ACTION._storeData(key, {
          companyPermissions: submission.companyPermissions,
        });
      } catch (err) {
        console.warn('Failed to save pending permissions', err);
      }
      apiOnboardSupplier(input)
        .then((response: IGenericResponse) => {
          this.setState({isSuccess: response.success});
          if (!response.success) alert(response.message);
        })
        .catch((err) => {
          alert('Error creating supplier. Please try again later');
          console.error(err);
        })
        .finally(() => this.setState({isLoading: false}));
    });
  }

  handleFormReset() {
    this.setState({isSuccess: false});
  }

  render() {
    const {isLoading, isSuccess} = this.state;

    return (
      <div className="table-screen invite-supplier-container">
        {/* <Typography variant="h5" className="page-title">*/}
        {/*  Onboard Supplier*/}
        {/* </Typography>*/}
        <InviteSupplierForm
          user={this.props.user}
          isLoading={isLoading}
          onSubmit={(submission) => this.handleFormSubmission(submission)}
          isSuccess={isSuccess}
          onReset={() => this.handleFormReset()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps)(InviteSupplier);
